import { Group, Menu, MantineColor, UnstyledButton } from '@mantine/core';
import Text from '@ui/components/Text/Text';
import ProjectRole, { ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import Icon from '@ui/components/Icon/Icon';
import { RoleOption } from './types';
import RoleSelectorItem from './RoleSelectorItem';

export type { RoleOption };

export type ProjectMemberRoleSelectorProps = {
	selectedRole: ProjectRole;
	roleOptions: RoleOption[];
	onChange?: ( role: ProjectMemberRoleType ) => void;
	onDelete?: () => void;
	readonly?: boolean;
	showRoles?: boolean;
	showDelete?: boolean;
	color?: MantineColor;
};

const menuStyles = {
	item: {
		padding: '4px'
	},
	itemIcon: {
		alignSelf: 'flex-start'
	},
	divider: {
		borderTopColor: 'var(--color-bg-surface)'
	}
};

const ProjectMemberRoleSelector = ( {
	selectedRole, roleOptions, onChange, onDelete, readonly = false, showRoles = true, showDelete = false, color = 'var(--color-text-secondary)'
}: ProjectMemberRoleSelectorProps ) => (
	<Menu
		shadow="md"
		position="bottom-end"
		styles={menuStyles}
		width={180}
		disabled={readonly}
		withinPortal
	>
		<Menu.Target>
			<UnstyledButton disabled={readonly} style={{ cursor: readonly ? 'default' : 'pointer' }}>
				<Group spacing={4} noWrap>
					<Text variant="footnote" color={color} sx={{ whiteSpace: 'nowrap' }}>
						{selectedRole.isLimitedEditor ? 'Editor' : selectedRole.name}
					</Text>
					{!readonly && <Icon icon="expand_more" size={20} color={color} />}
				</Group>
			</UnstyledButton>
		</Menu.Target>
		<Menu.Dropdown>
			{showRoles && roleOptions.map( ( option, index ) => (
				<RoleSelectorItem
					key={option.role.id}
					option={option}
					isSelected={option.role.id === selectedRole.id
						|| ( selectedRole.isLimitedEditor && option.role.id === ProjectMemberRoleType.ProjectEditor )}
					showDivider={showDelete || index < roleOptions.length - 1}
					onChange={onChange}
				/>
			) )}
			{showDelete && (
				<Menu.Item color="red" icon={<Icon icon="delete_outlined" size={14} />} onClick={onDelete}>
					<Text variant="footnote-semibold">Delete</Text>
				</Menu.Item>
			)}
		</Menu.Dropdown>
	</Menu>
);

export default ProjectMemberRoleSelector;
